module.exports = __webpack_public_path__ + "static/media/video_editing.82ac819a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/video_editing.jpg
// module id = 322
// module chunks = 0